import merge from 'lodash/merge';

import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';
import type { AxiosRequestConfig } from '@/types/axios';

export const axios = createAxiosInstance(env.communityApiUrl, {
  camelizeKeys: true,
});

export async function getConversation(
  {
    conversationId,
    limit,
    after,
    before,
    around,
  }: {
    conversationId: number;
    limit?: number;
    after?: string;
    before?: string;
    around?: string;
  },
  axiosConfig: AxiosRequestConfig = {},
) {
  const url = `/conversations/${conversationId}`;
  return axios.get(url, merge({ params: { limit, after, before, around } }, axiosConfig));
}

export async function createConversationMessage(
  conversationId: number,
  payload: { text: string },
  axiosConfig: AxiosRequestConfig = {},
) {
  const url = `/conversations/${conversationId}/messages`;
  return axios.post(url, payload, axiosConfig);
}

export async function updateConversation(
  conversationId: number,
  payload: { assigneeId?: number | null },
  axiosConfig: AxiosRequestConfig = {},
) {
  const url = `/conversations/${conversationId}`;
  return axios.patch(url, payload, axiosConfig);
}

export async function updateConversationMessages(
  conversationId: number,
  payload: { assigneeId?: number; closeConversationMessages?: boolean },
  axiosConfig: AxiosRequestConfig = {},
) {
  const url = `/conversations/${conversationId}/messages`;
  return axios.patch(url, payload, axiosConfig);
}

export async function updateMessage(
  messageId: number,
  payload: { reaction?: string | null },
  axiosConfig: AxiosRequestConfig = {},
) {
  const url = `/messages/${messageId}`;
  return axios.patch(url, payload, axiosConfig);
}
